import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-lms-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  @Input()
  orgName: string;

  @Input()
  capNumber: string;

  @Input()
  address: string;

  @Input()
  postalCode: string;

  @Input()
  state: string;

  @Input()
  city: string;

  @Input()
  firstAndLastName: string;

  @Output()
  closeConfirm = new EventEmitter<any>();

  @Output()
  confirm = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  onClose() {
    this.closeConfirm.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }

}
